import React, { Component } from 'react';
import panelActions from '../panel/action/panelActions';
import AddPanel from './addPanel';
import GridPanel from './gridPanel';
import UserPanel from './userPanel';
import CategoryPanel from './categoryPanel';
// import CalendarPanel from './calendarPanel';
import DateRangePicker from './search/dateRangePickerPanel';
import SearchPanel from './searchPanel';
import SideBarPanel from './search/sidebarPanel';
import classNames from 'classnames';
import CheckBoxPanel from './search/checkboxPanel';
import LinearCheckboxPanel from './search/linearcheckboxPanel';
import RadioBoxPanel from './search/radioboxPanel';
import SelectBoxPanel from './search/selectboxPanel';
import TextBoxPanel from './search/textboxPanel';
import TagPanel from './search/tagPanel';
import ImageSelectPanel from './search/imageselectPanel';
import RangeInputPanel from './search/rangeinputPanel';
import { findIndex } from 'underscore';
import clone from 'clone';
import SizeBoxPanel from './search/sizeboxPanel';
import ScrollBoxPannel from './search/scrolltabPannel';
import MapSearchBoxPanel from './search/mapsearchboxPanel';
import ColorBoxPannel from './search/colorboxPanel';
import ComboBoxPanel from './search/comboboxPanel';
import ResetButtonPanel from './search/resetbuttonPanel';
import MapPanel from './mapPanel';
import IsotopePanel from './isotopePanel';
import MapRadiusPanel from './search/mapRadiusPanel';
import RnbDatePickerPanel from './search/dateRangePickerPanel';

class EditPanel extends Component {
  constructor(props) {
    super(props);
    this.state = { modalIsOpen: false };
    this.hidePanel = this.hidePanel.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  hidePanel(e) {
    e.preventDefault();
    panelActions.togglePanel('', this.props.shortcodeKey);
  }
  openModal() {
    this.setState({ modalIsOpen: true });
  }
  closeModal() {
    this.setState({ modalIsOpen: false });
  }
  render() {
    let showPanel;
    const allLayout = clone(this.props.allLayout);
    const find = findIndex(allLayout, { uid: this.props.uid });
    let settings = {};
    if (find !== -1) {
      const findSearchIndex = findIndex(allLayout[find].searchAttr, { uid: this.props.childUid });
      if (findSearchIndex !== -1) {
        settings = { ..._.omit(allLayout[find].searchAttr[findSearchIndex], 'uid', 'viewType') };
      } else {
        settings = { ..._.omit(allLayout[find], 'uid', 'viewType') };
      }
    }

    switch (this.props.panelType) {
      case 'search-linearcheckbox':
        showPanel = <LinearCheckboxPanel {...this.props} settings={settings} />;
        break;
      case 'search-checkbox':
        showPanel = <CheckBoxPanel {...this.props} settings={settings} />;
        break;
      case 'search-radio':
        showPanel = <RadioBoxPanel {...this.props} settings={settings} />;
        break;
      case 'search-select':
        showPanel = <SelectBoxPanel {...this.props} settings={settings} />;
        break;
      case 'search-sizebox':
        showPanel = <SizeBoxPanel {...this.props} settings={settings} />;
        break;
      case 'search-colorbox':
        showPanel = <ColorBoxPannel {...this.props} settings={settings} />;
        break;
      case 'search-scrollbox':
        showPanel = <ScrollBoxPannel {...this.props} settings={settings} />;
        break;
      case 'search-text':
        showPanel = <TextBoxPanel {...this.props} settings={settings} />;
        break;
      case 'search-combobox':
        showPanel = <ComboBoxPanel {...this.props} settings={settings} />;
        break;
      case 'search-tag':
        showPanel = <TagPanel {...this.props} settings={settings} />;
        break;
      case 'search-imageselect':
        showPanel = <ImageSelectPanel {...this.props} settings={settings} />;
        break;
      case 'search-rangeinput':
        showPanel = <RangeInputPanel {...this.props} settings={settings} />;
        break;
      case 'search-rnb-daterange':
        showPanel = <DateRangePicker {...this.props} settings={settings} />;
        break;
      case 'search-sidebar':
        showPanel = <SideBarPanel {...this.props} />;
        break;
      case 'grid':
        showPanel = <GridPanel {...this.props} />;
        break;
      case 'isotope':
        showPanel = <IsotopePanel {...this.props} settings={settings}/>;
        break;
      case 'map':
        showPanel = <MapPanel {...this.props}/>;
        break;
      case 'search-mapsearch':
        showPanel = <MapSearchBoxPanel {...this.props} settings={settings} />;
        break;
      case 'user':
        showPanel = <UserPanel {...this.props} />;
        break;
      case 'category':
        showPanel = <CategoryPanel {...this.props} />;
        break;
      // case 'calendar':
      //   showPanel = <CalendarPanel {...this.props} />;
      //   break;
      case 'search-daterange':
        showPanel = <DateRangePicker {...this.props} settings={settings} />;
        break;
      case 'search-reset':
        showPanel = <ResetButtonPanel {...this.props} />;
        break;
      case 'search-mapradius':
        showPanel = <MapRadiusPanel {...this.props} settings={settings}/>;
        break;
      default:
        break;
    }
    const addClasses = classNames('editpanel', this.props.addClass);
    return (<div className={addClasses}>
        <div className="rightControl">
            <a className="hide-button" href="#" onClick={this.hidePanel}> <i className="fa fa-chevron-down"></i> </a>
        </div>
        <div className="scrollable-area">
          {showPanel}
        </div>
    </div>);
  }
}

EditPanel.propTypes = {
  'panelType': React.PropTypes.string,
  'shortcodeKey': React.PropTypes.number,
  'addClass': React.PropTypes.string,
};

export default EditPanel;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/panel/editPanel.js
 **/